import {ReactNode} from 'react';

import {Box, Modal} from '@mui/material';

export interface Props {
  open: boolean;
  children: ReactNode;
}

export const ProfileEditModal = ({open, children}: Props) => {
  return (
    <Modal open={open} aria-labelledby='modal-modal-title' aria-describedby='modal-modal-description'>
      <Box
        sx={(theme) => ({
          backgroundColor: 'white',
          backgroundImage: 'none',
          borderRadius: '16px',
          padding: {xs: '1.5rem', sm: '2rem'},
          position: 'absolute',
          width: '100%',
          maxWidth: '704px',
          maxHeight: '100vh',
          overflowY: 'auto',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          [theme.breakpoints.up('sm')]: {
            width: '704px',
          },
        })}
      >
        {children}
      </Box>
    </Modal>
  );
};
